import { getUsers, updateUser } from 'store/actions/user-action';
import { AppDispatch, RootState } from 'store/store';
import { User } from 'types/common_types';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export default () => {
  const dispatch: AppDispatch = useDispatch();
  const debounceTimer = useRef(null);

  const { users, delete_loading } = useSelector((state: RootState) => state.user);
  const { user } = useSelector((state: RootState) => state.common);

  const [isModalOpen, setModalOpen] = useState(false);
  const [sheetMode, setSheetMode] = useState<'create' | 'edit'>('create');
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const pageSize = 20;

  useEffect(() => {
    dispatch(getUsers({ pageSize, pageNumber: page }));
  }, []);

  const handleCreate = () => {
    setSheetMode('create');
    setSelectedUser(null);
    setModalOpen(true);
  };

  const handleEdit = (user: User) => {
    setSheetMode('edit');
    setSelectedUser(user);
    setModalOpen(true);
  };


  const onConfirmDeactivate = () => {
    const api_data = {
      ...selectedUser,
      isActive: selectedUser?.status === 'Active' ? false : true,
      updatedBy: user?.userId,
    };

    dispatch(
      updateUser(api_data, () => {
        setConfirmModal(false);
        onPageChange(1);
      }),
    );
  };

  const onPressDeactivate = (user: User) => {
    setSelectedUser(user);
    setConfirmModal(true);
  };

  const onPageChange = (newPage: number = page) => {
    setPage(newPage);
    dispatch(getUsers({ pageSize, pageNumber: newPage }));
  };

  const onSearch = (val: string) => {
    setSearch(val)
    debounceTimer.current = setTimeout(() => {
      dispatch(getUsers({ pageSize, pageNumber: page, search: val }));
    }, 500);
  }

  return {
    users,
    isModalOpen,
    sheetMode,
    selectedUser,
    handleCreate,
    handleEdit,
    setModalOpen,
    onPressDeactivate,
    onConfirmDeactivate,
    confirmModal,
    setConfirmModal,
    delete_loading,
    page,
    onPageChange,
    search,
    onSearch
  };
};
